import HTTP from '../http'
// const imgUrl = 'http://fdfs.cnknowledge.com/'
// const imgUrl = location.host.indexOf("dev.") != -1|| location.host.indexOf("test") != -1 || location.host.indexOf(":80") != -1 ? 'https://fdfs.cnknowledge.com/' : "https://kpp.cnknowledge.com/"
const imgUrl = process.env.VUE_APP_API_IMG_URL
// const imgUrl = 'http://fdfs.cnknowledge.com/'
const stimes = process.env.VUE_APP_API_URL;
export default {
  imgUrl,
  stimes
}